import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Nav, NavItem } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';
import { getEventIdFromUrl } from '@feathr/extender/utils';

function EventContentNav(): JSX.Element {
  const localUrl = useLocalUrl();
  const eventId = getEventIdFromUrl();
  const { t } = useTranslation();

  return (
    <Nav indented={true} label={'Project content navigation'} type={'vertical'}>
      <NavItem
        data-command={'true'}
        data-command-description={t('Manage project creatives and assets')}
        data-command-keywords={'creatives,assets,images,graphics'}
        data-command-label={t('Creatives')}
        to={localUrl(`/projects/${eventId}/content/creatives`)}
      >
        {t('Creatives')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Manage email templates')}
        data-command-keywords={'templates,email,designs'}
        data-command-label={t('Templates')}
        to={localUrl(`/projects/${eventId}/content/templates`)}
      >
        {t('Templates')}
      </NavItem>
      <NavItem
        data-command={'true'}
        data-command-description={t('Manage donation and signup forms')}
        data-command-keywords={'forms,donations,signup,landing'}
        data-command-label={t('Forms')}
        to={localUrl(`/projects/${eventId}/content/forms`)}
      >
        {t('Forms')}
      </NavItem>
    </Nav>
  );
}

export default observer(EventContentNav);
